import React, { useState, useEffect } from 'react';
import { apprenantsAPI, configAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
import FormInput from '../components/FormInput';
import FormSelect from '../components/FormSelect';
import Modal from '../components/Modal';
import * as XLSX from 'xlsx';
import api from '../services/api';
import Icon from '../components/Icon';

const Saisie = () => {
  const { isFormateur } = useAuth();
  const [formData, setFormData] = useState({
    matricule: '',
    nom: '',
    prenom: '',
    genre: '',
    dateNaissance: '',
    age: '',
    telephone: '',
    email: '',
    ville: '',
    region: '',
    diplome: '',
    statutEntree: '',
    typeFormation: '',
    filiere: '',
    formateur: '',
    dateDebut: new Date().toISOString().split('T')[0],
    dateFin: '',
    promotion: '',
    statutFormation: '',
    assiduite: '',
    statutInsertion: '',
    dateInsertion: '',
    situationSortie: '',
    situationM3: '',
    situationM6: '',
    typeContrat: '',
    entreprise: '',
    poste: '',
    dateDebutContrat: '',
    remuneration: '',
    salaireTranche: '',
    notes: '',
    referent: '',
    derniereDateContact: '',
    etatDossier: ''
  });
  const [config, setConfig] = useState(null);
  const [salaireMode, setSalaireMode] = useState('exact');
  const [showInsertion, setShowInsertion] = useState(true);
  const [showInsertionFields, setShowInsertionFields] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [addModalType, setAddModalType] = useState('');
  const [addModalValue, setAddModalValue] = useState('');
  const [addModalCategory, setAddModalCategory] = useState('positif');
  const [showImportModal, setShowImportModal] = useState(false);
  const [importFile, setImportFile] = useState(null);
  const [importPreview, setImportPreview] = useState([]);
  const [importData, setImportData] = useState(null);
  const [importForm, setImportForm] = useState({
    typeFormation: '',
    filiere: '',
    dateDebut: new Date().toISOString().split('T')[0],
    dateFin: '',
    promotion: ''
  });
  const [importLoading, setImportLoading] = useState(false);

  useEffect(() => {
    fetchConfig();
    const tomorrow = new Date();
    tomorrow.setMonth(tomorrow.getMonth() + 3);
    setFormData(prev => ({
      ...prev,
      dateFin: tomorrow.toISOString().split('T')[0]
    }));
  }, []);

  useEffect(() => {
    const isAcculturation = formData.typeFormation?.toLowerCase().includes('acculturation');
    setShowInsertion(!isAcculturation);
    if (isAcculturation) {
      setFormData(prev => ({ ...prev, statutInsertion: 'N/A' }));
    }
  }, [formData.typeFormation]);

  useEffect(() => {
    const positiveStatuses = ['Inséré', 'Auto-entrepreneur', 'Freelance'];
    setShowInsertionFields(positiveStatuses.includes(formData.statutInsertion));
  }, [formData.statutInsertion]);

  const fetchConfig = async () => {
    try {
      const response = await configAPI.get();
      setConfig(response.data);
    } catch (error) {
      toast.error('Erreur lors du chargement de la configuration');
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // If user edits date of birth, compute age automatically
    if (name === 'dateNaissance') {
      let computedAge = '';
      if (value) {
        const dob = new Date(value);
        const now = new Date();
        let ageYears = now.getFullYear() - dob.getFullYear();
        const m = now.getMonth() - dob.getMonth();
        if (m < 0 || (m === 0 && now.getDate() < dob.getDate())) {
          ageYears--;
        }
        computedAge = ageYears >= 0 ? String(ageYears) : '';
      }
      setFormData(prev => ({ ...prev, dateNaissance: value, age: computedAge }));
      return;
    }

    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormateur) {
      toast.error('Pas de droits');
      return;
    }

    setLoading(true);
    try {
      const dataToSend = {
        ...formData,
        age: formData.age ? parseInt(formData.age) : null,
        assiduite: formData.assiduite ? parseFloat(formData.assiduite) : null,
        salaire: salaireMode === 'exact' ? (formData.salaire ? parseInt(formData.salaire) : null) : null,
        salaireTranche: salaireMode === 'tranche' ? formData.salaireTranche : null,
        dateNaissance: formData.dateNaissance || null,
        dateInsertion: formData.dateInsertion || null,
        dateDebutContrat: formData.dateDebutContrat || null,
        derniereDateContact: formData.derniereDateContact || null
      };

      await apprenantsAPI.create(dataToSend);
      toast.success('Apprenant enregistré !');
      resetForm();
    } catch (error) {
      toast.error(error.response?.data?.message || 'Erreur lors de l\'enregistrement');
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    const tomorrow = new Date();
    tomorrow.setMonth(tomorrow.getMonth() + 3);
    setFormData({
      matricule: '',
      nom: '',
      prenom: '',
      genre: '',
      dateNaissance: '',
      age: '',
      telephone: '',
      email: '',
      ville: '',
      region: '',
      diplome: '',
      statutEntree: '',
      typeFormation: '',
      filiere: '',
      formateur: '',
      dateDebut: new Date().toISOString().split('T')[0],
      dateFin: tomorrow.toISOString().split('T')[0],
      promotion: '',
      statutFormation: '',
      assiduite: '',
      statutInsertion: '',
      dateInsertion: '',
      situationSortie: '',
      situationM3: '',
      situationM6: '',
      typeContrat: '',
      entreprise: '',
      poste: '',
      dateDebutContrat: '',
      remuneration: '',
      salaire: '',
      salaireTranche: '',
      notes: '',
      referent: '',
      derniereDateContact: '',
      etatDossier: ''
    });
    setSalaireMode('exact');
    setShowInsertionFields(false);
  };

  const openAddModal = (type, category = '') => {
    setAddModalType(type);
    setAddModalCategory(category);
    setAddModalValue('');
    setShowAddModal(true);
  };

  const handleAddItem = async () => {
    if (!addModalValue.trim()) {
      toast.error('Valeur requise');
      return;
    }

    try {
      await configAPI.addItem(addModalType, addModalValue.trim(), addModalCategory);
      await fetchConfig();
      setShowAddModal(false);
      toast.success('Élément ajouté !');
    } catch (error) {
      toast.error('Erreur lors de l\'ajout');
    }
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setImportFile(file);

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        let data = [];
        if (file.name.endsWith('.csv')) {
          const content = e.target.result;
          const lines = content.split('\n').filter(l => l.trim());
          if (lines.length === 0) return;

          const separator = lines[0].includes(';') ? ';' : ',';
          const headers = lines[0].split(separator).map(h => h.trim().toLowerCase());

          for (let i = 1; i < lines.length; i++) {
            const values = lines[i].split(separator);
            const row = {};
            headers.forEach((header, idx) => {
              row[header] = (values[idx] || '').trim();
            });
            if (row.nom || row.Nom || row.NOM) {
              data.push({
                nom: row.nom || row.Nom || row.NOM || '',
                prenom: row.prenom || row.Prenom || row.PRÉNOM || row.prénom || row.Prénom || '',
                genre: row.genre || row.Genre || row.sexe || row.Sexe || '',
                age: parseInt(row.age || row.Age || row.AGE || 0) || null,
                telephone: row.telephone || row.Telephone || row.tel || row.Tel || '',
                email: row.email || row.Email || row.EMAIL || row.mail || row.Mail || ''
              });
            }
          }
        } else {
          const wb = XLSX.read(e.target.result, { type: 'binary' });
          const jsonData = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
          data = jsonData.map(r => ({
            nom: r.Nom || r.nom || r.NOM || '',
            prenom: r.Prenom || r.prenom || r.Prénom || r.PRÉNOM || '',
            genre: r.Genre || r.genre || r.Sexe || r.sexe || '',
            age: parseInt(r.Age || r.age || r.AGE || 0) || null,
            telephone: r.Telephone || r.telephone || r.Tel || r.tel || '',
            email: r.Email || r.email || r.EMAIL || r.Mail || r.mail || ''
          })).filter(r => r.nom);
        }
        setImportData(data);
        setImportPreview(data.slice(0, 10));
      } catch (err) {
        toast.error('Erreur lors de la lecture du fichier: ' + err.message);
      }
    };

    if (file.name.endsWith('.csv')) {
      reader.readAsText(file);
    } else {
      reader.readAsBinaryString(file);
    }
  };

  const handleImport = async () => {
    if (!importFile || !importData || importData.length === 0) {
      toast.error('Veuillez sélectionner un fichier');
      return;
    }

    if (!importForm.typeFormation || !importForm.filiere || !importForm.dateDebut || !importForm.dateFin) {
      toast.error('Veuillez remplir tous les champs requis');
      return;
    }

    setImportLoading(true);
    try {
      const formData = new FormData();
      formData.append('file', importFile);
      formData.append('typeFormation', importForm.typeFormation);
      formData.append('filiere', importForm.filiere);
      formData.append('dateDebut', importForm.dateDebut);
      formData.append('dateFin', importForm.dateFin);
      if (importForm.promotion) {
        formData.append('promotion', importForm.promotion);
      }

      const response = await api.post('/apprenants/import', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      toast.success(`${response.data.count} apprenant(s) importé(s) !`);
      setShowImportModal(false);
      setImportFile(null);
      setImportData(null);
      setImportPreview([]);
      setImportForm({
        typeFormation: '',
        filiere: '',
        dateDebut: new Date().toISOString().split('T')[0],
        dateFin: '',
        promotion: ''
      });
    } catch (error) {
      toast.error(error.response?.data?.message || 'Erreur lors de l\'import');
    } finally {
      setImportLoading(false);
    }
  };

  if (!config) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600"></div>
      </div>
    );
  }

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-bold flex items-center">
          <Icon name="edit" size={24} className="mr-2" />
          Saisie
        </h2>
        <button
          onClick={() => {
            const tomorrow = new Date();
            tomorrow.setMonth(tomorrow.getMonth() + 3);
            setImportForm(prev => ({
              ...prev,
              dateFin: tomorrow.toISOString().split('T')[0]
            }));
            setShowImportModal(true);
          }}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
          📤 Import en Masse
        </button>
      </div>

      <div className="section-card bg-white rounded-xl p-6">
        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Informations Personnelles */}
          <div className="border-l-4 border-red-600 pl-4 bg-red-50 rounded-r-lg py-4 pr-4">
            <h3 className="font-bold text-red-800 mb-4 flex items-center">
              <Icon name="user" size={20} className="mr-2" />
              Informations Personnelles
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <FormInput
                label="ID Apprenant (Matricule)"
                name="matricule"
                value={formData.matricule}
                onChange={handleChange}
                placeholder="Ex: ID2025-0001"
              />

              <FormInput
                label="Nom"
                name="nom"
                value={formData.nom}
                onChange={handleChange}
                required
              />
              <FormInput
                label="Prénom"
                name="prenom"
                value={formData.prenom}
                onChange={handleChange}
              />
              <FormSelect
                label="Genre"
                name="genre"
                value={formData.genre}
                onChange={handleChange}
                required
                options={['Homme', 'Femme']}
              />
              <FormInput
                label="Date de naissance"
                name="dateNaissance"
                type="date"
                value={formData.dateNaissance}
                onChange={handleChange}
              />
              <div>
                <label htmlFor="saisie-age" className="block text-sm font-medium mb-1">Âge</label>
                <input
                  id="saisie-age"
                  name="age"
                  type="number"
                  min="15"
                  max="70"
                  value={formData.age}
                  onChange={handleChange}
                  readOnly={!!formData.dateNaissance}
                  disabled={!!formData.dateNaissance}
                  className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 ${formData.dateNaissance ? 'bg-gray-100 cursor-not-allowed' : ''
                    }`}
                  title={formData.dateNaissance ? "Calculé automatiquement à partir de la date de naissance" : ""}
                  autoComplete="off"
                />
                {formData.dateNaissance && (
                  <p className="mt-1 text-xs text-gray-500">Calculé automatiquement</p>
                )}
              </div>
              <FormInput
                label="Téléphone"
                name="telephone"
                type="tel"
                value={formData.telephone}
                onChange={handleChange}
              />
              <FormInput
                label="Email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
              />
              <FormInput
                label="Ville"
                name="ville"
                value={formData.ville}
                onChange={handleChange}
              />
              <FormInput
                label="Région"
                name="region"
                value={formData.region}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* Profil Entrée */}
          <div className="border-l-4 border-purple-600 pl-4 bg-purple-50 rounded-r-lg py-4 pr-4">
            <h3 className="font-bold text-purple-800 mb-4 flex items-center">
              <Icon name="document" size={20} className="mr-2" />
              Profil Entrée
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <FormSelect
                label="Niveau d'étude"
                name="diplome"
                value={formData.diplome}
                onChange={handleChange}
                options={config.diplomes || []}
                onAddNew={() => openAddModal('diplomes')}
                addLabel="+"
              />
              <FormSelect
                label="Statut entrée"
                name="statutEntree"
                value={formData.statutEntree}
                onChange={handleChange}
                required
                options={config.statutsEntree || []}
                onAddNew={() => openAddModal('statutsEntree')}
                addLabel="+"
              />
            </div>
          </div>

          {/* Formation */}
          <div className="border-l-4 border-blue-600 pl-4 bg-blue-50 rounded-r-lg py-4 pr-4">
            <h3 className="font-bold text-blue-800 mb-4 flex items-center">
              <Icon name="book" size={20} className="mr-2" />
              Formation
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <FormSelect
                label="Type"
                name="typeFormation"
                value={formData.typeFormation}
                onChange={handleChange}
                required
                options={config.typesFormation || []}
                onAddNew={() => openAddModal('typesFormation')}
                addLabel="+"
              />
              <FormSelect
                label="Referentiel"
                name="filiere"
                value={formData.filiere}
                onChange={handleChange}
                required
                options={config.filieres || []}
                onAddNew={() => openAddModal('filieres')}
                addLabel="+"
              />
              <FormInput
                label="Formateur"
                name="formateur"
                value={formData.formateur}
                onChange={handleChange}
              />
              <FormInput
                label="Date début"
                name="dateDebut"
                type="date"
                value={formData.dateDebut}
                onChange={handleChange}
                required
              />
              <FormInput
                label="Date fin"
                name="dateFin"
                type="date"
                value={formData.dateFin}
                onChange={handleChange}
                required
              />
              <FormSelect
                label="Promotion"
                name="promotion"
                value={formData.promotion}
                onChange={handleChange}
                options={config.promotions || []}
                onAddNew={() => openAddModal('promotions')}
                addLabel="+"
              />
              <FormSelect
                label="Statut Formation"
                name="statutFormation"
                value={formData.statutFormation}
                onChange={handleChange}
                options={config.statutsFormation || ['En cours', 'Validé', 'Abandon', 'Échec']}
                onAddNew={() => openAddModal('statutsFormation')}
                addLabel="+"
              />
              <FormInput
                label="Assiduité / Présence (%)"
                name="assiduite"
                type="number"
                min="0"
                max="100"
                step="0.1"
                value={formData.assiduite}
                onChange={handleChange}
                placeholder="Ex: 85.5"
              />
            </div>
          </div>

          {/* Insertion Professionnelle */}
          {showInsertion && (
            <div className="border-l-4 border-green-600 pl-4 bg-green-50 rounded-r-lg py-4 pr-4">
              <h3 className="font-bold text-green-800 mb-4 flex items-center">
                <Icon name="briefcase" size={20} className="mr-2" />
                Insertion Professionnelle
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                <FormSelect
                  label="Situation à la sortie"
                  name="situationSortie"
                  value={formData.situationSortie}
                  onChange={handleChange}
                  options={config.situationsSortie || ['En recherche', 'En emploi', 'En formation', 'Inactif']}
                  onAddNew={() => openAddModal('situationsSortie')}
                  addLabel="+"
                />
                <FormSelect
                  label="Situation à M+3"
                  name="situationM3"
                  value={formData.situationM3}
                  onChange={handleChange}
                  options={config.situationsSortie || ['En recherche', 'En emploi', 'En formation', 'Inactif']}
                  onAddNew={() => openAddModal('situationsSortie')}
                  addLabel="+"
                />
                <FormSelect
                  label="Situation à M+6"
                  name="situationM6"
                  value={formData.situationM6}
                  onChange={handleChange}
                  options={config.situationsSortie || ['En recherche', 'En emploi', 'En formation', 'Inactif']}
                  onAddNew={() => openAddModal('situationsSortie')}
                  addLabel="+"
                />
                <div>
                  <FormSelect
                    label="Statut"
                    name="statutInsertion"
                    value={formData.statutInsertion}
                    onChange={handleChange}
                    options={[
                      ...(config.statutsInsertion?.positif || []).map(s => ({ value: s, label: `✅ ${s}` })),
                      ...(config.statutsInsertion?.negatif || []).map(s => ({ value: s, label: `❌ ${s}` }))
                    ]}
                    onAddNew={() => openAddModal('statutsInsertion')}
                    addLabel="+"
                  />
                </div>
                {showInsertionFields && (
                  <>
                    <FormInput
                      label="Date insertion"
                      name="dateInsertion"
                      type="date"
                      value={formData.dateInsertion}
                      onChange={handleChange}
                    />
                    <FormSelect
                      label="Type contrat"
                      name="typeContrat"
                      value={formData.typeContrat}
                      onChange={handleChange}
                      options={config.typesContrat || []}
                      onAddNew={() => openAddModal('typesContrat')}
                      addLabel="+"
                    />
                    <FormInput
                      label="Entreprise"
                      name="entreprise"
                      value={formData.entreprise}
                      onChange={handleChange}
                    />
                    <FormInput
                      label="Poste"
                      name="poste"
                      value={formData.poste}
                      onChange={handleChange}
                    />
                    <FormInput
                      label="Date début du contrat"
                      name="dateDebutContrat"
                      type="date"
                      value={formData.dateDebutContrat}
                      onChange={handleChange}
                    />
                    <FormInput
                      label="Rémunération (optionnel)"
                      name="remuneration"
                      type="number"
                      min="0"
                      value={formData.remuneration}
                      onChange={handleChange}
                      placeholder="Montant en FCFA"
                    />

                    <div>
                      <label htmlFor="saisie-salaire-mode" className="block text-sm font-medium mb-1">Salaire</label>
                      <div className="flex gap-2 mb-2" role="radiogroup" aria-labelledby="saisie-salaire-mode-label">
                        <span id="saisie-salaire-mode-label" className="sr-only">Mode de saisie du salaire</span>
                        <label htmlFor="saisie-salaire-mode-exact" className="flex items-center">
                          <input
                            id="saisie-salaire-mode-exact"
                            type="radio"
                            name="salaireMode"
                            value="exact"
                            checked={salaireMode === 'exact'}
                            onChange={(e) => setSalaireMode(e.target.value)}
                            className="mr-1"
                          />
                          <span className="text-sm">Montant</span>
                        </label>
                        <label htmlFor="saisie-salaire-mode-tranche" className="flex items-center">
                          <input
                            id="saisie-salaire-mode-tranche"
                            type="radio"
                            name="salaireMode"
                            value="tranche"
                            checked={salaireMode === 'tranche'}
                            onChange={(e) => setSalaireMode(e.target.value)}
                            className="mr-1"
                          />
                          <span className="text-sm">Tranche</span>
                        </label>
                      </div>
                      {salaireMode === 'exact' ? (
                        <FormInput
                          label="Montant salaire"
                          name="salaire"
                          type="number"
                          value={formData.salaire}
                          onChange={handleChange}
                          placeholder="Montant en FCFA"
                        />
                      ) : (
                        <FormSelect
                          label="Tranche salariale"
                          name="salaireTranche"
                          value={formData.salaireTranche}
                          onChange={handleChange}
                          options={config.tranchesSalariales || []}
                        />
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          )}

          {/* Suivi Administratif / Accompagnement */}
          <div className="border-l-4 border-amber-600 pl-4 bg-amber-50 rounded-r-lg py-4 pr-4">
            <h3 className="font-bold text-amber-800 mb-4 flex items-center">
              <Icon name="phone" size={20} className="mr-2" />
              Suivi Administratif / Accompagnement
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <FormSelect
                label="Référent / Coach"
                name="referent"
                value={formData.referent}
                onChange={handleChange}
                options={config.referents || []}
                onAddNew={() => openAddModal('referents')}
                addLabel="+"
                placeholder="Sélectionner un référent"
              />
              <FormInput
                label="Dernière date de contact"
                name="derniereDateContact"
                type="date"
                value={formData.derniereDateContact}
                onChange={handleChange}
              />
              <FormSelect
                label="État du dossier"
                name="etatDossier"
                value={formData.etatDossier}
                onChange={handleChange}
                options={config.etatsDossier || ['Complet', 'Pièces manquantes']}
                onAddNew={() => openAddModal('etatsDossier')}
                addLabel="+"
              />
            </div>
          </div>

          {/* Notes */}
          <div>
            <label htmlFor="saisie-notes" className="block text-sm font-medium mb-1">Notes / Observations</label>
            <textarea
              id="saisie-notes"
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              rows="3"
              autoComplete="off"
              className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
              placeholder="Commentaires et observations..."
            />
          </div>

          {/* Boutons */}
          <div className="flex justify-end gap-3 pt-4 border-t">
            <button
              type="button"
              onClick={resetForm}
              className="flex items-center gap-2 px-6 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors"
            >
              <Icon name="refresh" size={18} />
              <span>Réinitialiser</span>
            </button>
            <button
              type="submit"
              disabled={loading}
              className="flex items-center gap-2 px-6 py-2 bg-red-600 text-white rounded-lg font-semibold hover:bg-red-700 disabled:opacity-50 transition-colors"
            >
              <Icon name={loading ? 'refresh' : 'save'} size={18} className={loading ? 'animate-spin' : ''} />
              <span>{loading ? 'Enregistrement...' : 'Enregistrer'}</span>
            </button>
          </div>
        </form>
      </div>

      {/* Modal d'ajout */}
      <Modal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        title={
          <span className="flex items-center">
            <Icon name="add" size={20} className="mr-2" />
            Ajouter {addModalType === 'statutsInsertion' ? 'statut' : addModalType}
          </span>
        }
        size="sm" zIndex={10001}
      >
        {addModalType === 'statutsInsertion' && (
          <div className="mb-4">
            <label htmlFor="add-modal-category" className="block text-sm font-medium mb-1">Catégorie</label>
            <select
              id="add-modal-category"
              name="category"
              value={addModalCategory}
              onChange={(e) => setAddModalCategory(e.target.value)}
              autoComplete="off"
              className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
            >
              <option value="positif">Positif</option>
              <option value="negatif">Négatif</option>
            </select>
          </div>
        )}
        <div className="mb-4">
          <label htmlFor="add-modal-value" className="block text-sm font-medium mb-1">Valeur</label>
          <input
            id="add-modal-value"
            name="value"
            type="text"
            value={addModalValue}
            onChange={(e) => setAddModalValue(e.target.value)}
            autoComplete="off"
            className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
            placeholder="Nouvel élément..."
          />
        </div>
        <div className="flex gap-3">
          <button
            onClick={() => setShowAddModal(false)}
            className="flex-1 py-2 bg-gray-200 rounded-lg hover:bg-gray-300"
          >
            Annuler
          </button>
          <button
            onClick={handleAddItem}
            className="flex-1 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
          >
            Ajouter
          </button>
        </div>
      </Modal>

      {/* Modale Import en Masse */}
      <Modal
        isOpen={showImportModal}
        onClose={() => {
          setShowImportModal(false);
          setImportFile(null);
          setImportData(null);
          setImportPreview([]);
        }}
        title={
          <span className="flex items-center">
            <Icon name="upload" size={20} className="mr-2" />
            Import en Masse
          </span>
        }
        size="lg"
      >
        <div className="space-y-4">
          <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded-r-lg text-sm">
            <p><strong>Formats :</strong> Excel (.xlsx), CSV (.csv)</p>
            <p><strong>Colonnes :</strong> Nom, Prénom, Genre, Age, Telephone, <b>Email</b></p>
          </div>

          <div>
            <label htmlFor="massImportFile" className="block text-sm font-medium mb-1 sr-only">Fichier à importer</label>
            <div
              className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center hover:border-red-400 cursor-pointer"
              onClick={() => document.getElementById('massImportFile').click()}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  document.getElementById('massImportFile').click();
                }
              }}
              aria-label="Sélectionner un fichier à importer"
            >
              <input
                type="file"
                id="massImportFile"
                name="massImportFile"
                accept=".xlsx,.xls,.csv"
                className="hidden"
                onChange={handleFileSelect}
                aria-label="Fichier à importer"
              />
              <Icon name="upload" size={48} className="mx-auto mb-3 text-gray-400" />
              <p className="text-gray-600">Cliquez pour sélectionner</p>
              {importFile && (
                <p className="text-sm text-gray-500 mt-2">{importFile.name}</p>
              )}
            </div>
          </div>

          {importPreview.length > 0 && (
            <div className="mb-4">
              <p className="font-medium text-green-600 mb-2">
                <span>{importData.length}</span> lignes détectées
              </p>
              <div className="max-h-40 overflow-y-auto bg-gray-50 rounded-lg border">
                <table className="w-full text-sm">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="p-2 text-left">Nom</th>
                      <th className="p-2 text-left">Prenom</th>
                      <th className="p-2 text-center">Genre</th>
                      <th className="p-2 text-center">Âge</th>
                      <th className="p-2 text-center">Tél</th>
                      <th className="p-2 text-center">Email</th>
                    </tr>
                  </thead>
                  <tbody>
                    {importPreview.map((row, idx) => (
                      <tr key={idx}>
                        <td className="p-2">{row.nom}</td>
                        <td className="p-2">{row.prenom || '-'}</td>
                        <td className="p-2 text-center">{row.genre || '-'}</td>
                        <td className="p-2 text-center">{row.age || '-'}</td>
                        <td className="p-2 text-center">{row.telephone || '-'}</td>
                        <td className="p-2 text-center">{row.email || '-'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label htmlFor="import-type-formation" className="block text-sm font-medium mb-1">Type Formation *</label>
              <div className="flex gap-2">
                <FormSelect
                  id="import-type-formation"
                  name="typeFormation"
                  label=""
                  value={importForm.typeFormation}
                  onChange={(e) => setImportForm(prev => ({ ...prev, typeFormation: e.target.value }))}
                  options={config?.typesFormation || []}
                  required
                  className="flex-1"
                />
                <button
                  type="button"
                  onClick={() => openAddModal('typesFormation', 'Ajouter type')}
                  className="px-3 py-2 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200"
                  aria-label="Ajouter un type de formation"
                >
                  +
                </button>
              </div>
            </div>
            <div>
              <label htmlFor="import-filiere" className="block text-sm font-medium mb-1">Référentiel *</label>
              <div className="flex gap-2">
                <FormSelect
                  id="import-filiere"
                  name="filiere"
                  label=""
                  value={importForm.filiere}
                  onChange={(e) => setImportForm(prev => ({ ...prev, filiere: e.target.value }))}
                  options={config?.filieres || []}
                  required
                  className="flex-1"
                />
                <button
                  type="button"
                  onClick={() => openAddModal('filieres', 'Ajouter filière')}
                  className="px-3 py-2 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200"
                  aria-label="Ajouter une filière"
                >
                  +
                </button>
              </div>
            </div>
            <div>
              <label htmlFor="import-date-debut" className="block text-sm font-medium mb-1">Date Début *</label>
              <input
                id="import-date-debut"
                name="dateDebut"
                type="date"
                value={importForm.dateDebut}
                onChange={(e) => setImportForm(prev => ({ ...prev, dateDebut: e.target.value }))}
                autoComplete="off"
                required
                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
              />
            </div>
            <div>
              <label htmlFor="import-date-fin" className="block text-sm font-medium mb-1">Date Fin *</label>
              <input
                id="import-date-fin"
                name="dateFin"
                type="date"
                value={importForm.dateFin}
                onChange={(e) => setImportForm(prev => ({ ...prev, dateFin: e.target.value }))}
                autoComplete="off"
                required
                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
              />
            </div>
            <div className="col-span-2">
              <label htmlFor="import-promotion" className="block text-sm font-medium mb-1">Promotion</label>
              <div className="flex gap-2">
                <FormSelect
                  id="import-promotion"
                  name="promotion"
                  label=""
                  value={importForm.promotion}
                  onChange={(e) => setImportForm(prev => ({ ...prev, promotion: e.target.value }))}
                  options={config?.promotions || []}
                  className="flex-1"
                />
                <button
                  type="button"
                  onClick={() => openAddModal('promotions', 'Ajouter promotion')}
                  className="px-3 py-2 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200"
                  aria-label="Ajouter une promotion"
                >
                  +
                </button>
              </div>
            </div>
          </div>

          <button
            onClick={handleImport}
            disabled={!importFile || importData?.length === 0 || importLoading}
            className="w-full flex items-center justify-center gap-2 py-3 bg-red-600 text-white rounded-lg font-semibold disabled:opacity-50 disabled:cursor-not-allowed hover:bg-red-700 transition-colors"
          >
            <Icon name={importLoading ? 'refresh' : 'upload'} size={18} className={importLoading ? 'animate-spin' : ''} />
            <span>{importLoading ? 'Import en cours...' : 'Importer'}</span>
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default Saisie;
